import { createFileRoute } from '@tanstack/react-router';
import type { Id } from '@aeon-karaoke/cloud-convex/_generated/dataModel';
import { PackPage } from '@/page/PackPage';

export const Route = createFileRoute('/_app/library/packs/$packId')({
  params: { parse: ({ packId }) => ({ packId: packId as Id<'packs'> }) },
  component: PackRoute,
});

function PackRoute() {
  const { packId } = Route.useParams();
  return <PackPage packId={packId} />;
}
